import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "diary-show" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", null, "Verstreken werkdagen", -1)
const _hoisted_3 = { style: {"font-size":"14px"} }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", null, "Onwerkbare werkdagen", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", null, "Resterende werkdagen", -1)
const _hoisted_6 = { style: {"font-size":"14px"} }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { style: {"font-size":"12px","font-weight":"400"} }
const _hoisted_9 = {
  key: 0,
  style: {"font-weight":"500"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Is de dagstart gehouden door de uitvoerder?"),
  /*#__PURE__*/_createElementVNode("li", null, "Zijn alle nieuwe medewerkers op de bouwplaats ingeschreven met de projectinformatie?"),
  /*#__PURE__*/_createElementVNode("li", null, "Is er werkbezoek interne veiligheids kundige Henk Tijssen?"),
  /*#__PURE__*/_createElementVNode("li", null, "Is er een Toolbox gehouden met ZZPèrs / CAOèrs die we rechtsreeks inhuren?"),
  /*#__PURE__*/_createElementVNode("li", null, "Zijn er vandaag nieuwe werkzaamheden gestart waar we een TRA moeten maken – bijzondere gevallen die niet in het V&G plan zijn omschreven maar wel een verhoogd risico aan vast zit?")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Zijn er vandaag specifieke keuringen op de planning volgens WKB en/of energielabel?"),
  /*#__PURE__*/_createElementVNode("li", null, "Bezoek Niemann?"),
  /*#__PURE__*/_createElementVNode("li", null, "Bezoek Bouw-inspecteur gemeente?"),
  /*#__PURE__*/_createElementVNode("li", null, "Bezoek WKB-inspecteur?"),
  /*#__PURE__*/_createElementVNode("li", null, "Overige keuringen?")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Is de standlijn op overal planning gemaakt?"),
  /*#__PURE__*/_createElementVNode("li", null, "2-wekelijke planning duidelijk bij alle onderaannemers – leveranciers?")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Interne vergadering met projectteam gehouden?"),
  /*#__PURE__*/_createElementVNode("li", null, "Verslaglegging van dit interne overleg?"),
  /*#__PURE__*/_createElementVNode("li", null, "2-wekelijks projectleiders overleg met de betrokken partijen?"),
  /*#__PURE__*/_createElementVNode("li", null, "Verslaglegging van dit overleg ook gedeeld?")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Meer-minderwerk elke week afronden door Thunnissen en desbetreffende onderaannemer/ leverancier")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Zijn er leveringen gedaan? Koppel hier de leveringsbonnen."),
  /*#__PURE__*/_createElementVNode("li", null, "Overige documenten.")
], -1)

import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { diaryStore } from '@/stores/diary'
import PageTitleBar from '@/components/PageTitleBar.vue'
import Column from '@/types/column'
import { DiaryRegistration } from '@/types/diary'
import { CheckOutlined, FileOutlined } from '@ant-design/icons-vue'
import Filelist from '@/components/Filelist.vue'
import { authStore } from '@/stores/auth'
import { can } from '@/globalFunctions'


export default /*#__PURE__*/_defineComponent({
  __name: 'DiaryShow',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const canView = computed(() => {
  return {
    files: can('construction_site_portal.diariesFiles.view'),
    signaling: can('construction_site_portal.diariesSignaling.view')
  }
})

const diaryColumns = ref<Column[]>([
  {
    title: 'Dag',
    key: 'day',
    width: 100
  },
  {
    title: 'Werkbaar',
    key: 'workable',
    width: 320
  },
  {
    title: 'Omschrijving van de dag',
    key: 'description'
  }
])

const registrationColumns = ref<Column[]>([
  {
    title: 'Bedrijf',
    key: 'company',
    width: 200
  },
  {
    title: 'Maandag',
    key: 'monday'
  },
  {
    title: 'Dinsdag',
    key: 'tuesday'
  },
  {
    title: 'Woensdag',
    key: 'wednesday'
  },
  {
    title: 'Donderdag',
    key: 'thursday'
  },
  {
    title: 'Vrijdag',
    key: 'friday'
  },
  {
    title: 'Zaterdag',
    key: 'saturday'
  },
  {
    title: 'Zondag',
    key: 'sunday'
  }
])

const registrationsCounter = computed(() => {
  const counter = { monday: 0, tuesday: 0, wednesday: 0, thursday: 0, friday: 0, saturday: 0, sunday: 0 }

  if (!diaryStore().diary) return counter

  diaryStore().diary.registrations.forEach((r:DiaryRegistration) => {
    counter.monday += r.monday
    counter.tuesday += r.tuesday
    counter.wednesday += r.wednesday
    counter.thursday += r.thursday
    counter.friday += r.friday
    counter.saturday += r.saturday
    counter.sunday += r.sunday
  })

  return counter
})

const diaryClosed = computed(() => {
  return diaryStore().diary?.status === 0
})

onMounted(() => {
  diaryStore().getDiary(route.params.diaryId.toString())
})

onBeforeUnmount(() => {
  diaryStore().diary = null
  diaryStore().errors = {}
})

function downloadReport () : void {
  window.open(diaryStore().diary.pdf?.url, '_blank')
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_statistic = _resolveComponent("a-statistic")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_table_summary_cell = _resolveComponent("a-table-summary-cell")!
  const _component_a_table_summary_row = _resolveComponent("a-table-summary-row")!
  const _component_a_table_summary = _resolveComponent("a-table-summary")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageTitleBar, null, {
      title: _withCtx(() => [
        _createTextVNode("Uitvoerdersdagboek")
      ]),
      subtitle: _withCtx(() => [
        (_unref(diaryStore)().diary && _unref(diaryStore)().diary.project)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_unref(diaryStore)().diary.project.name), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode("Aan het laden..")
            ], 64))
      ]),
      buttons: _withCtx(() => [
        _createVNode(_component_a_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'Diaries' })))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Terug naar overzicht")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, { gutter: [16, 16] }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 8 }, {
          default: _withCtx(() => [
            (_unref(diaryStore)().diary)
              ? (_openBlock(), _createBlock(_component_a_card, {
                  key: 0,
                  bordered: false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_statistic, {
                      value: _unref(diaryStore)().diary.schedule.elapsed_work_days
                    }, {
                      title: _withCtx(() => [
                        _hoisted_2
                      ]),
                      suffix: _withCtx(() => [
                        _createElementVNode("span", _hoisted_3, "/ " + _toDisplayString(_unref(diaryStore)().diary.schedule.scheduled_days), 1)
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 8 }, {
          default: _withCtx(() => [
            (_unref(diaryStore)().diary)
              ? (_openBlock(), _createBlock(_component_a_card, {
                  key: 0,
                  bordered: false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_statistic, {
                      value: _unref(diaryStore)().diary.schedule.non_workable_days
                    }, {
                      title: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 8 }, {
          default: _withCtx(() => [
            (_unref(diaryStore)().diary)
              ? (_openBlock(), _createBlock(_component_a_card, {
                  key: 0,
                  bordered: false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_statistic, {
                      value: _unref(diaryStore)().diary.schedule.remaining_work_days
                    }, {
                      title: _withCtx(() => [
                        _hoisted_5
                      ]),
                      suffix: _withCtx(() => [
                        _createElementVNode("span", _hoisted_6, "/ " + _toDisplayString(_unref(diaryStore)().diary.schedule.scheduled_days), 1)
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            (_unref(diaryStore)().diary)
              ? (_openBlock(), _createBlock(_component_a_card, {
                  key: 0,
                  bordered: false
                }, {
                  title: _withCtx(() => [
                    _createTextVNode(" Week " + _toDisplayString(_unref(diaryStore)().diary.week) + ", " + _toDisplayString(_unref(diaryStore)().diary.year), 1),
                    _hoisted_7,
                    _createElementVNode("span", _hoisted_8, "Van " + _toDisplayString(new Date(_unref(diaryStore)().diary.dates.monday).toLocaleDateString('nl-NL')) + " t/m " + _toDisplayString(new Date(_unref(diaryStore)().diary.dates.sunday).toLocaleDateString('nl-NL')), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_row, {
                      gutter: [16,16],
                      class: "no-mb"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, {
                          xs: {span: 24},
                          sm: {span: 24},
                          md: {span: 24},
                          lg: {span: 24}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_table, {
                              columns: diaryColumns.value,
                              "data-source": _unref(diaryStore)().diary.days,
                              pagination: false,
                              scroll: { x: true },
                              class: "diary-table"
                            }, {
                              bodyCell: _withCtx(({ column, record }) => [
                                (column.key === 'day')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(record.day), 1))
                                  : _createCommentVNode("", true),
                                (column.key === 'workable')
                                  ? (_openBlock(), _createBlock(_component_a_radio_group, {
                                      key: 1,
                                      "button-style": "solid",
                                      style: { display: 'inline-flex' },
                                      value: record.workable,
                                      "onUpdate:value": ($event: any) => ((record.workable) = $event),
                                      disabled: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_radio_button, { value: 1 }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Ja")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_radio_button, { value: 2 }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Half")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_radio_button, { value: 0 }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Nee")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_radio_button, {
                                          value: 3,
                                          style: {"width":"max-content"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Geen werkdag")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["value", "onUpdate:value"]))
                                  : _createCommentVNode("", true),
                                (column.key === 'description')
                                  ? (_openBlock(), _createBlock(_component_a_collapse, {
                                      key: 2,
                                      class: "diary-collapse",
                                      bordered: false,
                                      accordion: true
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_collapse_panel, { header: "Veiligheid" }, {
                                          extra: _withCtx(() => [
                                            (record.text_safety && record.text_safety.length > 3)
                                              ? (_openBlock(), _createBlock(_unref(CheckOutlined), {
                                                  key: 0,
                                                  style: { color: 'green' }
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          default: _withCtx(() => [
                                            _hoisted_10,
                                            _createVNode(_component_a_textarea, {
                                              value: record.text_safety,
                                              "onUpdate:value": ($event: any) => ((record.text_safety) = $event),
                                              disabled: ""
                                            }, null, 8, ["value", "onUpdate:value"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_a_collapse_panel, { header: "Kwaliteit" }, {
                                          extra: _withCtx(() => [
                                            (record.text_quality && record.text_quality.length > 3)
                                              ? (_openBlock(), _createBlock(_unref(CheckOutlined), {
                                                  key: 0,
                                                  style: { color: 'green' }
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          default: _withCtx(() => [
                                            _hoisted_11,
                                            _createVNode(_component_a_textarea, {
                                              value: record.text_quality,
                                              "onUpdate:value": ($event: any) => ((record.text_quality) = $event),
                                              disabled: ""
                                            }, null, 8, ["value", "onUpdate:value"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_a_collapse_panel, { header: "Voortgang" }, {
                                          extra: _withCtx(() => [
                                            (record.text_progress && record.text_progress.length > 3)
                                              ? (_openBlock(), _createBlock(_unref(CheckOutlined), {
                                                  key: 0,
                                                  style: { color: 'green' }
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          default: _withCtx(() => [
                                            _hoisted_12,
                                            _createVNode(_component_a_textarea, {
                                              value: record.text_progress,
                                              "onUpdate:value": ($event: any) => ((record.text_progress) = $event),
                                              disabled: ""
                                            }, null, 8, ["value", "onUpdate:value"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_a_collapse_panel, { header: "Overlegstructuur" }, {
                                          extra: _withCtx(() => [
                                            (record.text_consultation_structure && record.text_consultation_structure.length > 3)
                                              ? (_openBlock(), _createBlock(_unref(CheckOutlined), {
                                                  key: 0,
                                                  style: { color: 'green' }
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          default: _withCtx(() => [
                                            _hoisted_13,
                                            _createVNode(_component_a_textarea, {
                                              value: record.text_consultation_structure,
                                              "onUpdate:value": ($event: any) => ((record.text_consultation_structure) = $event),
                                              disabled: ""
                                            }, null, 8, ["value", "onUpdate:value"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_a_collapse_panel, { header: "Overige zaken" }, {
                                          extra: _withCtx(() => [
                                            (record.text_other && record.text_other.length > 3)
                                              ? (_openBlock(), _createBlock(_unref(CheckOutlined), {
                                                  key: 0,
                                                  style: { color: 'green' }
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          default: _withCtx(() => [
                                            _hoisted_14,
                                            _createVNode(_component_a_textarea, {
                                              value: record.text_other,
                                              "onUpdate:value": ($event: any) => ((record.text_other) = $event),
                                              disabled: ""
                                            }, null, 8, ["value", "onUpdate:value"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _withDirectives(_createVNode(_component_a_collapse_panel, { header: "Bestanden" }, {
                                          extra: _withCtx(() => [
                                            _createVNode(_unref(FileOutlined)),
                                            _createTextVNode(" " + _toDisplayString(record.files.length), 1)
                                          ]),
                                          default: _withCtx(() => [
                                            _hoisted_15,
                                            (record.files.length)
                                              ? (_openBlock(), _createBlock(Filelist, {
                                                  key: 0,
                                                  media: record.files,
                                                  "can-delete": false
                                                }, null, 8, ["media"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1536), [
                                          [_vShow, _unref(canView).files]
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["columns", "data-source"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_a_card, {
                  key: 1,
                  title: "Aan het laden..",
                  bordered: false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_skeleton, { active: "" })
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }),
        (_unref(diaryStore)().diary)
          ? (_openBlock(), _createBlock(_component_a_col, {
              key: 0,
              span: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_card, {
                  title: "Aanwezigheid",
                  bordered: false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_row, { gutter: [16,16] }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, {
                          xs: {span: 24},
                          sm: {span: 24},
                          md: {span: 24},
                          lg: {span: 24}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_table, {
                              columns: registrationColumns.value,
                              "data-source": _unref(diaryStore)().diary.registrations,
                              pagination: false,
                              scroll: { x: true }
                            }, {
                              bodyCell: _withCtx(({ column, record }) => [
                                (column.key === 'company')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(record.company.name), 1)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (column.key === 'monday')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(record.monday), 1)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (column.key === 'tuesday')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                      _createTextVNode(_toDisplayString(record.tuesday), 1)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (column.key === 'wednesday')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                      _createTextVNode(_toDisplayString(record.wednesday), 1)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (column.key === 'thursday')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                      _createTextVNode(_toDisplayString(record.thursday), 1)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (column.key === 'friday')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                      _createTextVNode(_toDisplayString(record.friday), 1)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (column.key === 'saturday')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                      _createTextVNode(_toDisplayString(record.saturday), 1)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (column.key === 'sunday')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                      _createTextVNode(_toDisplayString(record.sunday), 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]),
                              summary: _withCtx(() => [
                                _createVNode(_component_a_table_summary, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_table_summary_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_table_summary_cell, { style: { fontWeight: 800 } }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Totaal")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_table_summary_cell, { style: { fontWeight: 800 } }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(registrationsCounter).monday), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_table_summary_cell, { style: { fontWeight: 800 } }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(registrationsCounter).tuesday), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_table_summary_cell, { style: { fontWeight: 800 } }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(registrationsCounter).wednesday), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_table_summary_cell, { style: { fontWeight: 800 } }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(registrationsCounter).thursday), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_table_summary_cell, { style: { fontWeight: 800 } }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(registrationsCounter).friday), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_table_summary_cell, { style: { fontWeight: 800 } }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(registrationsCounter).saturday), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_table_summary_cell, { style: { fontWeight: 800 } }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(registrationsCounter).sunday), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_table_summary_cell)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["columns", "data-source"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})